import React from "react";
import { MessageCircle, ClipboardList, HeartHandshake } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageCircle,
    title: "Kostenloses Erstgespräch",
    text: "Wir besprechen deine Situation, Beschwerden und Ziele – offen und ohne Verkaufsdruck.",
  },
  {
    n: "02",
    icon: ClipboardList,
    title: "Individueller Trainings- & Nährstoffplan",
    text: "Basierend auf deinem Status, nicht auf Standardvorlagen. Training und Mikronährstoffe greifen ineinander.",
  },
  {
    n: "03",
    icon: HeartHandshake,
    title: "Persönliche Begleitung",
    text: "Regelmäßige Anpassung, echte Betreuung statt App-Algorithmus. Du hast immer einen Ansprechpartner.",
  },
];

export default function ProductSection() {
  return (
    <section
      id="product-intro-section"
      data-testid="product-intro-section"
      className="bg-[#F7F9FB] text-[#1F2937] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Left intro + image */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <p className="text-xs sm:text-sm font-semibold tracking-[0.18em] uppercase text-[#2E89C4] mb-5">
              Alex Buchner Health
            </p>
            <h2
              data-testid="product-title"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1]"
            >
              Personal Training{" "}
              <span className="text-[#6FB04F]">&</span> Mikronährstoffberatung
              – aus einer Hand.
            </h2>
            <p className="mt-6 text-[#1F2937]/70 text-base lg:text-lg leading-relaxed">
              Für Menschen, die nachhaltige Ergebnisse statt schneller
              Versprechen wollen.
            </p>

            <div className="mt-10 rounded-2xl overflow-hidden border border-[#1F2937]/10">
              <img
                src="https://images.unsplash.com/photo-1512621776951-a57141f2eefd"
                alt="Frische, nährstoffreiche Lebensmittel"
                className="w-full h-64 lg:h-80 object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right steps */}
          <div className="lg:col-span-7 relative">
            <ol className="space-y-6 lg:space-y-8">
              {STEPS.map((s, i) => {
                const Icon = s.icon;
                return (
                  <li
                    key={i}
                    data-testid={`product-step-${i}`}
                    className="relative rounded-2xl border border-[#1F2937]/10 bg-white/70 backdrop-blur-sm p-7 lg:p-9 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-25px_rgba(43,43,43,0.35)] hover:border-[#6FB04F]/40"
                  >
                    <div className="flex items-start gap-6">
                      <div className="shrink-0">
                        <div className="font-display text-5xl lg:text-6xl font-extrabold text-[#6FB04F] leading-none">
                          {s.n}
                        </div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-3">
                          <div className="h-10 w-10 rounded-lg bg-[#2E89C4]/10 flex items-center justify-center">
                            <Icon
                              size={18}
                              className="text-[#2E89C4]"
                              strokeWidth={1.8}
                            />
                          </div>
                          <h3 className="font-display text-xl lg:text-2xl font-bold">
                            {s.title}
                          </h3>
                        </div>
                        <p className="text-[15px] lg:text-base text-[#1F2937]/75 leading-relaxed">
                          {s.text}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
